import { render, staticRenderFns } from "./pick-number-new.vue?vue&type=template&id=364ff0fe&scoped=true&"
import script from "./pick-number-new.vue?vue&type=script&lang=js&"
export * from "./pick-number-new.vue?vue&type=script&lang=js&"
import style0 from "./pick-number-new.vue?vue&type=style&index=0&id=364ff0fe&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364ff0fe",
  null
  
)

export default component.exports